import { render, staticRenderFns } from "./exchangeOrder.vue?vue&type=template&id=a7a8e420&scoped=true&"
import script from "./exchangeOrder.vue?vue&type=script&lang=js&"
export * from "./exchangeOrder.vue?vue&type=script&lang=js&"
import style0 from "./exchangeOrder.vue?vue&type=style&index=0&id=a7a8e420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a8e420",
  null
  
)

component.options.__file = "exchangeOrder.vue"
export default component.exports